module.exports = __webpack_public_path__ + "img/wechat_work_qr_code.d0c401d2.png";